// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__Fpeii","label":"Radio_label__7UYbF","checkMark":"Radio_checkMark__8Nmdc","disabled":"Radio_disabled__3vu66"};